import {
  FETCH_WITHDRAWS,
  FETCH_WITHDRAWS_SUCCESS,
  FETCH_WITHDRAWS_FAILED,
  EDIT_WITHDRAWS
} from "../store/types";
import { getSupabase } from '../config/configureSupabase';

export const fetchWithdraws = () => async (dispatch) => {
  dispatch({
    type: FETCH_WITHDRAWS,
    payload: null
  });

  dispatch({
    type: FETCH_WITHDRAWS_SUCCESS,
    payload: []
  });
};

export const completeWithdraw = (entry) => async (dispatch) => {
  dispatch({
    type: EDIT_WITHDRAWS,
    payload: entry
  });

  const supabase = getSupabase();
  if (supabase && entry?.id) {
    try {
      await supabase.from('withdraws').update({
        processed: true,
        status: 'completed',
        updated_at: new Date().toISOString()
      }).eq('id', entry.id);
    } catch (e) {}
  }
};